const GET_ALL_POSTS = 'GET_ALL_POSTS';
const GET_SINGLE_POST = 'GET_SINGLE_POST';
const GET_USER_ADMIN = "GET_USER_ADMIN";
const GET_SINGLE_USER = 'GET_SINGLE_USER';
const POST_USER = 'POST_USER';
const SEARCH_BY_TITLE = 'SEARCH_BY_TITLE';
const CATEGORY_POST = "CATEGORY_POST";
const CATEGORY_SPECEALTY = "CATEGORY_SPECEALTY";
const GET_FILTER_TYPE = 'GET_FILTER_TYPE';
const USER_LOGIN = 'USER_LOGIN';
const USER_DATA_COMPLETE = "USER_DATA_COMPLETE"
const GET_ALL_REVIEWS = 'GET_ALL_REVIEWS';
const POST_REVIEW = 'POST_REVIEW'
const GET_MP_ORDER_INFO = "GET_MP_ORDER_INFO"
const GET_REVIEW = "GET_REVIEW"
const ADD_FAVORITE_POST = "ADD_FAVORITE_POST"
const GET_FAVORITE_POST = "GET_FAVORITE_POST"
const REMOVE_FAVORITE_POST ="REMOVE_FAVORITE_POST"
const GET_JOB_PETITIONS = 'GET_JOB_PETITIONS'
const GET_JOB_OFFERS = 'GET_JOB_OFFERS'
const GET_ALL_REPORT = 'GET_ALL_REPORT'
const GET_ALL_ORDER = 'GET_ALL_ORDER'



module.exports = {
    USER_DATA_COMPLETE,
    USER_LOGIN,
    GET_ALL_POSTS,
    GET_SINGLE_POST,
    GET_USER_ADMIN,
    GET_SINGLE_USER,
    SEARCH_BY_TITLE,
    POST_USER,
    CATEGORY_POST,
    CATEGORY_SPECEALTY,
    GET_FILTER_TYPE,
    GET_ALL_REVIEWS,
    POST_REVIEW,
    GET_MP_ORDER_INFO,
    GET_REVIEW,
    ADD_FAVORITE_POST,
    GET_FAVORITE_POST,
    REMOVE_FAVORITE_POST,
    GET_JOB_PETITIONS, 
    GET_JOB_OFFERS,
    GET_ALL_REPORT,
    GET_ALL_ORDER
}